import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=7bb87e74&scoped=true&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=7bb87e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb87e74",
  null
  
)

export default component.exports